import { http } from '@noor/api';
import { env } from '@noor/config';
import { restaurantSchema, type Restaurant } from '../model/schema';

/**
 * Restaurant admin API on the Eats host (`VITE_EATS_API_URL`, paths carry
 * `/api/v1`). Only the branch-name read is wired — the moderation review
 * modals resolve `restaurant_id` to a display name through it.
 */

const eatsBase = { baseURL: env.VITE_EATS_API_URL };

/**
 * Unwrap the detail envelope (`{data:{restaurant}}` per
 * `openapi-eats-admin.json`, `{data}` / flat kept as fallbacks). Pure, so the
 * envelope shapes stay covered without mocking `http`.
 */
export function normalizeRestaurantDetail(raw: unknown): Restaurant | undefined {
  const root = (raw ?? {}) as Record<string, unknown>;
  const data = (root.data ?? {}) as Record<string, unknown>;
  const candidate = data.restaurant ?? root.restaurant ?? root;
  const parsed = restaurantSchema.safeParse(candidate);
  if (!parsed.success) return undefined;
  if (parsed.data.id == null && parsed.data.name == null) return undefined;
  return parsed.data;
}

export const restaurantApi = {
  /** Branch detail by id — `undefined` when the row carries no identity. */
  async detail(restaurantId: string): Promise<Restaurant | undefined> {
    const raw = await http.get<unknown>(
      `/api/v1/admin/restaurants/${restaurantId}`,
      eatsBase,
    );
    return normalizeRestaurantDetail(raw);
  },
};
